import QRCode from 'qrcode';

const url = 'https://erp.sys-in.com.cn/#/device-info';

export function initDeviceLabel({
   iframe,
   company,
   deviceName,
   deviceModel,
   deviceNo,
   isSubDevice,
  }) {
  let doc = iframe.contentWindow.document;
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  const qrcodeText = `${url}?deviceNo=${encodeURIComponent(deviceNo)}`;
  const titlePrefix = isSubDevice ? '组件' : '设备';
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .container {
                    text-align: center;
                    font-family: ${titleFontFamily},serif;
                }
                h3 {
                    margin: 10px auto;
                    font-weight: normal;
                }
                .infoContainer {
                    display: flex;
                    justify-content: space-between;
                    text-align: left;
                }
                .basicInfoContainer {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                .title {
                    margin-left: 20px;
                }
                .info {
                    margin-left: 20px;
                }
                #labelQrCode {
                    margin-right: 20px;
                }
            </style>
            </head>
            <body>
                <div class="container">
                    <h3>${company}</h3>
                    <div class="infoContainer">
                        <div class="basicInfoContainer">
                            <p><span class="title">${titlePrefix}名称</span><span class="info">${deviceName}</span></p>
                            <p><span class="title">${titlePrefix}型号</span><span class="info">${deviceModel}</span></p>
                            <p><span class="title">${titlePrefix}编号</span><span class="info">${deviceNo}</span></p>
                        </div>
                        <canvas id="labelQrCode"></canvas>
                    </div>
                </div>
            </body>
        </html>
  `);
  const canvas = doc.getElementById('labelQrCode');
  QRCode.toCanvas(canvas, qrcodeText, {width: 100}, function (error) {
    if (error) console.error(error);
  });
  doc.close();
  return iframe;
}
